import { render } from "./event-setup-card.vue?vue&type=template&id=53599e70"
import script from "./event-setup-card.vue?vue&type=script&lang=js"
export * from "./event-setup-card.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__